import { AbiFunction } from 'ox';
import { htlcFunctions } from '../../abi.js';
import { DEFAULT_FEE_LIMIT, FUNCTION_SIGNATURES } from '../../constants.js';
import { toEvmHex, toTronHex } from '../../address.js';
import { encodeParams, hex } from '../../utils.js';
export function buildRedeemSolverTx(params) {
    const calldata = AbiFunction.encodeData(htlcFunctions.redeemSolver, [
        hex(params.id),
        toEvmHex(params.solverAddress),
        BigInt(params.secret),
    ]);
    return {
        contractAddress: toTronHex(params.contractAddress),
        functionSelector: FUNCTION_SIGNATURES.redeemSolver,
        parameter: encodeParams(calldata),
        callValue: 0,
        feeLimit: DEFAULT_FEE_LIMIT,
    };
}
